import { ChangeEvent, SyntheticEvent } from 'react';
import { NumberFormatBase } from 'react-number-format';
import { Field, Input, InputProps, InputValue } from '@optimus-web/core';

export type PaymentCardExpirationProps = Omit<InputProps, 'type' | 'defaultValue'>;

const PaymentCardExpirationElement = ({ onChange, ...props }: PaymentCardExpirationProps) => {
    const handleChange = (event?: SyntheticEvent<HTMLInputElement>, inputValue?: InputValue) => {
        if (onChange && event) {
            onChange(event as ChangeEvent<HTMLInputElement>, inputValue || '');
        }
    };

    /**
     * Inspired by https://s-yadav.github.io/react-number-format/docs/customization#card-expiry-field
     */
    const format = (val: string) => {
        if (val === '') return '';
        let month = val.substring(0, 2);
        const year = val.substring(2, 4);

        if (month.length === 1 && Number(month[0]) > 1) {
            month = `0${month[0]}`;
        } else if (month.length === 2) {
            if (Number(month) === 0) {
                month = `01`;
            } else if (Number(month) > 12) {
                month = '12';
            }
        }

        return month.length === 2 ? `${month}/${year}` : month;
    };

    return (
        <NumberFormatBase
            {...props}
            customInput={Input}
            format={format}
            onValueChange={(values, sourceInfo) => {
                handleChange(sourceInfo.event, values.formattedValue);
            }}
        />
    );
};
export const PaymentCardExpiration = Field(PaymentCardExpirationElement);
